import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { Toast } from "primereact/toast";
import { toastShow } from "../../../Base/Services/ToastService";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { ListadoOrdenesCompraAuth } from "../../../API/Compras/Requisas/PurchareDetailsRequests";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";

const RequisasOverlayPanel = ({
  setNuevaFila,
  selectedPcs,
  setSelectedPCs,
  habilitar,
  Functions,
  IdProveedor,
  IdMoneda,
  IsPro,
}) => {
  const lo = useRef(null);
  const toast = useRef();

  const { userAuth } = useContext(AuthContext);

  const [requisasAuth, setRequisasAuth] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);

  const openOver = (e) => {
    const camposValidos = Functions.verificarCamposEncabezado();
    if (camposValidos) {
      return;
    } else {
      setShouldFetch(true);
      lo.current.toggle(e);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const tempo = await ListadoOrdenesCompraAuth();
      const filteredData = tempo.filter((item) => {
        return (
          (!IdProveedor || item.IdProveedor === IdProveedor) &&
          (!IdMoneda || item.IdCurrency === IdMoneda)
        );
      });

      setRequisasAuth(IsPro ? filteredData : tempo);
    } catch (error) {
      toastShow(toast, "error", "Error", "Error al obtener los datos");
    } finally {
      setLoading(false);
    }
  };

  const AsignarInformacion = () => {
    if (Functions.verificarCamposEncabezado()) {
      lo.current.hide();
    } else {
      setNuevaFila(selectedPcs);
      lo.current.hide();
      setSelectedPCs([]);
    }
  };

  const columns = [
    {
      field: 'IdPurcharesRequestDetail',
      header: 'ID',
      className: "Xsmall",
      alignFrozen: "left",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
    },
    {
      // REQUISA
      field: "PurchaseRequest",
      header: "Requisa",
      className: "small",
      sortable: true,
      filter: true,
    },
    {
      // PRODUCTO
      field: "NombreProducto",
      header: "Producto",
      className: "large",
      sortable: true,
      filter: true,
    },
    {
      // CATEGORIA
      field: "NombreCategoria",
      header: "Categoria",
      className: "medium",
      sortable: true,
      filter: true,
    },
    {
      // TIPO
      field: "NombreTipo",
      header: "Tipo",
      className: "small",
      sortable: true,
      filter: true,
    },
    {
      // ORDEN DE VENTA
      field: "IdSalesOrder",
      header: "Orden de venta",
      className: "medium",
      sortable: true,
      filter: true,
    },
    {
      // PRECIO
      field: "Price",
      header: "Precio",
      Format: "Currency",
      className: "small",
      sortable: true,
      filter: true,
    },
    {
      // MONEDA
      field: "CurrencySymbol",
      header: "Moneda",
      className: "XXsmall",
      Format: "Center",
      sortable: true,
      filter: true,
    },
    {
      // CANTIDAD
      field: "Quantity",
      header: "Cantidad",
      Format: "Currency",
      className: "small",
      sortable: true,
      filter: true,
    },
    {
      // UNIDAD
      field: "UnitSimbol",
      header: "Unidad",
      className: "XXsmall",
      Format: "Center",
      sortable: true,
      filter: true,
    },
    {
      // SUBTOTAL
      field: "SubTotal",
      header: "SubTotal",
      className: "small",
      Format: "Currency",
      sortable: true,
      filter: true,
    },
    {
      // DESCUENTO
      field: "Descuento",
      header: "Descuento",
      className: "small",
      Format: "Currency",
      sortable: true,
      filter: true,
    },
    {
      // TOTAL
      field: "Total",
      header: "Total",
      className: "small",
      Format: "Currency",
      sortable: true,
      filter: true,
    },
  ];

  useEffect(() => {
    if (shouldFetch) {
      fetchData();
      setShouldFetch(false);
    }
  }, [shouldFetch, IsPro]);

  useEffect(() => {
    fetchData();
  }, [IdProveedor, IdMoneda, IsPro]);

  const table = {
    Data: requisasAuth,
    selected: selectedPcs,
    setSelected: setSelectedPCs,
    Columns: columns,
    loading: loading,
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="p-inputgroup mx-2">
        <Button
          label="Agregar Requisas"
          onClick={() => AsignarInformacion()}
          disabled={!selectedPcs || selectedPcs?.length === 0}
        />
        <Button
          icon="pi pi-angle-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => openOver(e)}
          disabled={habilitar}
        />
      </div>
      <OverlayPanel ref={lo} showCloseIcon dismissable={false}>
        <div style={{ height: "55vh", width: "80vw" }} id="FacturasPagoCliente">
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default RequisasOverlayPanel;
